<template>
  <div class="filter-container">
    <a href="#" @click.prevent="toggleShow" class="filter-header">
      <i class="fa" :class="show ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
      <span>Filter</span>
      <i class="fa fa-filter" v-if="!allProjectsActive || !allUsersActive"></i>
    </a>
    <div v-if="show">
      <h6>Projects</h6>
      <a href="#" class="filter" :class="{active: allProjectsActive}" @click.prevent="toggleAllProjects">
        <div class="box"></div>
        All
      </a>
      <a href="#"
         class="filter"
         :class="{active: isProjectActive(project)}"
         :key="project.id"
         v-for="project in projects"
         @click.prevent="toggleProject(project)"
      >
        <div class="box" :style="projectBoxStyle(project)"></div>
        {{project.title}}
      </a>
    </div>

    <div v-if="show">
      <h6>Users</h6>
      <a href="#" class="filter" :class="{active: allUsersActive}" @click.prevent="toggleAllUsers">
        <div class="box"></div>
        All
      </a>
      <a href="#" class="filter" :class="{active: isUserActive(noUser)}" @click.prevent="toggleUser(noUser)" v-if="showNoUser">
        <div class="box"></div>
        {{noUserLabel}}
      </a>
      <a href="#"
         class="filter"
         :class="{active: isUserActive(user)}"
         :key="user.id"
         v-for="user in users"
         @click.prevent="toggleUser(user)"
      >
        <img :src="user.iconUrl" class="icon-box" />
        {{user.fullname}}
      </a>
    </div>
    
    <div v-if="show && showSearch" class="search-container mt-2">
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-search fa" aria-hidden="true" id="search"></i></div>
        </div>
        <input type="text" ref="searchbar" @input="onSearch" class="form-control" placeholder="Search..." id="search" />
      </div>
    </div>
  </div>
</template>

<script>
 export default {
   props: [
     'users',
     'projects',
     'showNoUser',
     'showSearch',
     'noUserLabel',
   ],
   data() {
     return {
       'selectedUsers': [],
       'selectedProjects': [],
       'searchTerm': "",
       'show': false,
       'searchTimeout': null,
     };
   },
   created: function() {
     if (this.showSearch) {
       window.addEventListener('keydown', this.onkey);
     }
     
   },
   watch: {
     selectedUsers() {
       this.emitSelect();
     },
     selectedProjects() {
       this.emitSelect();
     },
     searchTerm() {
       this.emitSelect();
     }
   },
   computed: {
     allUsersActive() {
       return this.showNoUser ?
              this.selectedUsers.length === this.users.length + 1 :
              this.selectedUsers.length === this.users.length;
     },
     allProjectsActive() {
       return this.selectedProjects.length === this.projects.length;
     },
     noUser() {
       return {
         id: -1,
       };
     },
   },
   methods: {
     emitSelect() {
       this.$emit('select', {
         users: this.selectedUsers,
         projects: this.selectedProjects,
         searchTerm: this.searchTerm,
       });
     },
     isUserActive(user) {
       return this.selectedUsers.indexOf(user.id) !== -1;
     },
     isProjectActive(project) {
       return this.selectedProjects.indexOf(project.id) !== -1;
     },
     toggleUser(user) {
       var index = this.selectedUsers.indexOf(user.id);
       if (index !== -1) {
         this.selectedUsers.splice(index, 1);
       } else {
         this.selectedUsers.push(user.id);
       }
       this.updateCookie('users');
     },
     onSearch(e) {
       // debounce the search to aid smooth typing
       if (this.searchTimeout) {
         clearTimeout(this.searchTimeout);
       }
       this.searchTimeout = setTimeout(() => {
         this.searchTerm = e.target.value;
       }, 40);
     },
     onkey(e) {
       if (e.key === "/"  && document.activeElement.tagName != "INPUT") {
         e.preventDefault();
         if (!this.show) {
           this.show = true;
         }
         if (this.selectedUsers.length == 0) {
           this.toggleAllUsers();
         }
         if (this.selectedProjects.length == 0) {
           this.toggleAllProjects();
         }
         this.$nextTick(() => {
           this.$refs.searchbar.focus();
         })
         
       }
     },
     toggleProject(project) {
       var index = this.selectedProjects.indexOf(project.id);
       if (index !== -1) {
         this.selectedProjects.splice(index, 1);
       } else {
         this.selectedProjects.push(project.id);
       }
       this.updateCookie('projects');
     },
     toggleAllUsers() {
       if (this.allUsersActive) {
         this.selectedUsers = [];
       } else {
         this.selectAllUsers();
       }
       this.updateCookie('users');
     },
     toggleAllProjects() {
       if (this.allProjectsActive) {
         this.selectedProjects = [];
       } else {
         this.selectAllProjects();
       }
       this.updateCookie('projects');
     },
     toggleShow() {
       this.show = !this.show;
       $.cookie('show-filters', this.show, { path: window.location.pathname });
     },
     updateCookie(name) {
       let ids = name === 'users' ? this.selectedUsers : this.selectedProjects;
       $.cookie(name, ids, { path: window.location.pathname });
     },
     updateFromCookie() {
       const cookieVal = $.cookie('users');
       const savedUsers = cookieVal ? cookieVal.split(',') : [];
       if (savedUsers) {
         this.selectedUsers = this.users
                                  .filter(user => savedUsers.includes(user.id))
                                  .map(user => user.id);
         if (this.showNoUser && savedUsers.includes('-1')) {
           this.selectedUsers.push(-1);
         }
       } else {
         this.selectAllUsers();
       }

       const projectId = this.parseProjectFromUrl();
       if (projectId) {
         this.selectedProjects = [projectId];
       } else {
         const cookieVal = $.cookie('projects');
         const savedProjects = cookieVal ? cookieVal.split(',') : [];
         if (savedProjects) {
           this.selectedProjects = this.projects
                                       .filter(user => savedProjects.includes(user.id))
                                       .map(user => user.id);
         } else {
           this.selectAllProjects();
         }
       }

       this.show = $.cookie('show-filters') === 'true' ? true : false;
     },
     parseProjectFromUrl() {
       const queryString = document.location.search;
       const pieces = (queryString[0] === '?' ? queryString.substring(1) : queryString).split('&');
       for (let i = 0; i < pieces.length; i++) {
         let fragments = pieces[i].split('=');
         if (fragments[0] === 'project') {
           return fragments[1];
         }
       }
     },
     selectAllUsers() {
       this.selectedUsers = this.users.map(user => user.id);
       if (this.showNoUser) {
         this.selectedUsers.push(-1);
       }
     },
     selectAllProjects() {
       this.selectedProjects = this.projects.map(user => user.id);
     },
     projectBoxStyle(project) {
       let style = {
         borderColor: project.color,
       };
       if (this.isProjectActive(project)) {
         style.backgroundColor = project.color;
       }
       return style;
     },
   }
 }
</script>



// WEBPACK FOOTER //
// assets/js/components/work-logs/Filters.vue